module.exports = __webpack_public_path__ + "static/media/yellowInfo.e62a46a9.svg";